export default __webpack_public_path__ + "static/media/Legendary.22d5798a.svg";